import React, { Fragment, useEffect, useState } from "react";
import GiftCodeCard from "../../global/GiftCodeCard";
import {
  DatabaseZap,
  Eye,
  FolderKanban,
  Gift,
  Plus,
  TicketX,
} from "lucide-react";

import { Constant } from "../../util/Constant";
import MyLoader from "../../util/MyLoader";
import { addGiftCode, getAllServices, getInventory } from "../apps_manage/api";

import { useNavigate } from "react-router-dom";
import { SolidButton } from "../../global/SolidButton";
import { MyModal } from "../../global/MyModal";
import { format } from "date-fns";
import toast from "react-hot-toast";

export default function GiftCodes() {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(1);
  const [totalGiftCodes, setTotalGiftCodes] = useState(0);
  const [availableGiftCodes, setAvailableGiftCodes] = useState(0);
  const [usedGiftCodes, setUsedGiftCodes] = useState(0);
  const [inventory, setInventory] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);

  //data
  const [service, setService] = useState("");
  const [amount, setAmount] = useState(10);
  const [expireAt, setExpireAt] = useState(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d;
  });
  const [code, setCode] = useState("");
  const [errors, setErrors] = useState({});
  const [services, setServices] = useState([]);

  const predefinedAmounts = [10, 20, 30, 50, 100, 200, 500, 1000];

  const colorClasses = {
    blue: {
      text: "text-blue-600",
      icon_bg: "bg-blue-600/20",
      progress_bg: "bg-blue-600",
    },
    green: {
      text: "text-green-600",
      icon_bg: "bg-green-600/20",
      progress_bg: "bg-green-600",
    },
    red: {
      text: "text-red-600",
      icon_bg: "bg-red-600/20",
      progress_bg: "bg-red-600",
    },
    yellow: {
      text: "text-yellow-500",
      icon_bg: "bg-yellow-500/20",
      progress_bg: "bg-yellow-500",
    },
    purple: {
      text: "text-purple-600",
      icon_bg: "bg-purple-600/20",
      progress_bg: "bg-purple-600",
    },
  };

  const validateForm = () => {
    const errs = {};
    if (code === "") {
      errs.code = "gift code is required";
    }

    // if (service === "") {
    //   errs.service = "service is required";
    // }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    //  console.log("Submitting form with data:", { code, amount, service, expireAt });

    try {
      const payload = {
        code: code,
        amount: amount,
        service: service,
        gateway: "adwave",
        expires_at: expireAt,
      };

      const res = await addGiftCode(payload);
      if (res?.status === 200) {
        // success toast
        toast.success("Gift code added successfully");
        setIsModelOpen(false);
        fetchInventory();
      }
    } catch (error) {
      console.error("Error adding gift code:", error);
      // error toast
      toast.error("Failed to add gift code");
    }
  };

  const fetchInventory = async () => {
    try {
      // Simulate API call delay
      const res = await getInventory();
      if (res?.status === 200) {
        const data = res?.data;
        setTotalGiftCodes(data.total);
        setAvailableGiftCodes(data.available);
        setUsedGiftCodes(data.used);
        setInventory(data.inventory || []);
      }
    } catch (error) {
      console.error("Error fetching gift card data:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchServices = async () => {
    try {
      // Simulate API call delay
      const res = await getAllServices("adwave");
      if (res?.status === 200) {
        const data = res?.data;
        setServices(data.services || []);
        setService(data.services[0] || ""); // set default service
      }
    } catch (error) {
      console.error("Error fetching service data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInventory();
    fetchServices();
  }, []);

  // const data = giftCodesData;
  const type = [
    { id: 1, label: "All", value: "all" },
    { id: 2, label: "Available", value: "available" },
    { id: 3, label: "Used", value: "used" },
  ];

  const navigate = useNavigate();
  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/payout/giftcodes?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };
  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4">
        {/* grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          <GiftCodeCard
            color={colorClasses.purple}
            icon={Gift}
            smallIcon={DatabaseZap}
            title="Total Gift Codes"
            value={totalGiftCodes}
          />
          <GiftCodeCard
            color={colorClasses.green}
            icon={FolderKanban}
            smallIcon={FolderKanban}
            title="Available Gift Codes"
            value={availableGiftCodes}
            progressPercentage={(availableGiftCodes / totalGiftCodes) * 100}
          />

          <GiftCodeCard
            color={colorClasses.red}
            icon={TicketX}
            smallIcon={TicketX}
            title="Used Gift Codes"
            value={usedGiftCodes}
            progressPercentage={(0 / totalGiftCodes) * 100}
          />
        </div>
        <div className="w-full flex items-end justify-end mt-10">
          <SolidButton
            className="py-1 px-2   "
            onClick={() => setIsModelOpen(true)}
          >
            <Plus size={14} />
            <span>Add Gift Code</span>
          </SolidButton>
        </div>
        <div
          className="bg-white/80 dark:bg-slate-900/80
       backdrop-blur-xl rounded-2xl  
       border border-state-200/50 dark:border-slate-700/50 
        w-full 
       overflow-x-auto
      "
        >
          <div className="flex items-center justify-center p-4 ">
            <div className="flex flex-col space-y-1 ">
              <h1 className="text-sm text-slate-900 dark:text-slate-200 font-bold">
                Inventory Overview
              </h1>
              <span className="text-xs text-slate-500 :dark:text-slate-200 font-normal">
                Grouped by type and amount
              </span>
            </div>
            {/* tabs */}
            <div
              className="flex ml-auto py-2 p-2 bg-slate-300/25 dark:bg-gray-700/30 backdrop-blur-xl rounded-lg   
              "
            >
              {type.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={` text-xs font-medium border 
                 mr-2
           p-1 rounded-sm transition-all duration-200 transform
           text-slate-800 dark:text-slate-300 font-normal ${
             tab.id === activeTab
               ? "bg-white dark:bg-slate-100/2 border dark:via-slate-800 dark:to-slate-900 border-slate-300"
               : "border-transparent cursor-pointer"
           }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          {/* Table */}
          <table className="min-w-full ">
            <thead className="w-full">
              <tr className=" bg-slate-100 dark:bg-slate-800/60 border-t   border-slate-300 dark:border-slate-700">
                <th className="text-start   text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-4">
                  Type
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Amount
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Total Count
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Available
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 pe-20">
                  Used
                </th>
              </tr>
            </thead>
            <tbody>
              {inventory.map((item, index) => (
                <tr
                  key={index}
                  className="w-full hover:bg-slate-100 dark:hover:bg-gray-800/20"
                >
                  <td className="text-start   text-sm font-normal  text-slate-900 dark:text-slate-200 py-2 ps-4">
                    {item.service}
                  </td>

                  <td className="text-start py-3  flex justify-center ">
                    <span className="text-sm font-normal  text-green-600 dark:text-gray-100 rounded-full px-2 py-1 bg-green-600/10 dark:bg-green-500/15">
                      {Constant.UniCode.rupees + item.amount}
                    </span>
                  </td>

                  <td className="text-center  text-sm font-bold text-slate-900 dark:text-slate-200 py-3  ">
                    {item.total}
                  </td>

                  <td className="text-start py-3  flex justify-center space-x-2">
                    <span className="text-sm font-semibold flex justify-center items-center  text-green-600 dark:text-gray-100  ">
                      {item.available}
                    </span>
                    <span className="text-sm font-normal flex justify-center items-center  text-green-600 dark:text-gray-100 rounded-full px-2  bg-green-600/10 dark:bg-green-500/15">
                      {parseInt(((item.total - item.used) / item.total) * 100)}%
                    </span>
                  </td>

                  <td className="text-start py-3 pe-12">
                    <div className="flex justify-center items-center space-x-2 ">
                      <span className="text-sm font-semibold  text-red-600 dark:text-red-100  ">
                        {item.used}
                      </span>
                      <span className="text-sm font-normal   text-red-600 dark:text-gray-100 rounded-full px-2  bg-red-600/10 dark:bg-red-500/15">
                        {parseInt((item.used / item.total) * 100)}%
                      </span>
                    </div>
                  </td>
                  <td>
                    <Eye
                      onClick={() => {
                        navigate(`/payout/giftcodes/${item.id}`);
                      }}
                      className="text-blue-500  cursor-pointer"
                      size={18}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <MyModal
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        title="Add New Gift Card"
        width="530px"
      >
        <div className="flex flex-col space-y-4 ">
          {/* Service */}
          <div className="flex flex-col col-span-1 mt-4">
            <label className=" text-xs  font-medium text-black-600 dark:text-slate-500  ">
              Service
            </label>
            <select
              name="service"
              value={service} // defaultValue={service}
              onChange={(e) => {
                setService(e.target.value);
              }}
              className={`w-full px-2  py-2 
                  bg-slate-100 dark:bg-slate-800 
                  border  
                  rounded-md mt-2
                  text-slate-800 dark:text-white text-xs
                  placeholder-slate-500 focus:outline-none focus:ring-2
                  focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
            >
              {services.map((service) => (
                <option key={service} value={service}>
                  {service}
                </option>
              ))}
            </select>
          </div>
          {/* Amount */}
          <div className="mt-2">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Gift Anount*
            </label>
            {/* Chips */}
            <div className="flex flex-wrap gap-2 mb-2">
              {predefinedAmounts.map((amt) => (
                <button
                  key={amt}
                  type="button"
                  onClick={() => setAmount(amt)}
                  className={`px-3 py-1.5 text-xs rounded-full border transition-all
          ${
            amount == amt
              ? "bg-blue-500 text-white border-blue-500"
              : "bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-white border-slate-300 dark:border-slate-600 hover:bg-blue-100/40"
          }`}
                >
                  ₹{amt}
                </button>
              ))}
            </div>
            {/* Input */}
            <input
              type="number"
              placeholder="Enter gift Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
            />
          </div>
          {/* Code */}
          <div className="mt-2">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Gift Code*
            </label>

            {/* Input */}
            <input
              type="text"
              placeholder="e.g. ABCD-1234-EFGH"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                if (errors.code)
                  setErrors((prev) => ({ ...prev, code: undefined }));
              }}
              className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                errors.code
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />
            {errors.code && (
              <div className="text-xs text-red-500 mt-1">{errors.code}</div>
            )}
          </div>
          {/* Expire */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Expire At*
            </label>

            <div className="relative cursor-pointer">
              {/* Input */}
              <input
                type="date"
                placeholder="e.g. 2024-12-31"
                value={expireAt ? format(expireAt, "yyyy-MM-dd") : ""}
                min={format(new Date(), "yyyy-MM-dd")} // ✅ restrict past dates
                onChange={(e) => {
                  setExpireAt(new Date(e.target.value)); // ✅ convert to Date
                }}
                // readOnly
                className="w-full text-xs py-2.5 pl-9 pr-3 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
              />
            </div>
          </div>
          {/* action */}
          <div className="flex items-center justify-end space-x-4 mt-4 ml-auto">
            <button
              className="px-4 py-2 rounded-lg
                           bg-slate-400/20 dark:bg-slate-800 
                           text-slate-800 dark:text-slate-300 text-sm font-semibold
                           hover:bg-slate-400/30 dark:hover:bg-slate-700 
                           transition-all duration-300"
              onClick={() => {
                setIsModelOpen(false);
                setErrors({});
              }}
            >
              Cancel
            </button>
            <SolidButton
              children={<span>Add New</span>}
              onClick={(e) => {
                handleSubmit(e);
              }}
            />
          </div>
        </div>
      </MyModal>
    </Fragment>
  );
}
